module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-43.3ec2079b.png";